// extracted by mini-css-extract-plugin
module.exports = {"main":"Main1_main__1j2Vu"};